export const queryKey = {
  CURRENCY: "currency",
  COUNTRY: "country",
  USER_INFO: "userInfo",
  DAILY_CHECK: "dailyCheck",
  HOME_DAILY_CHECK: "homeDailyCheck",
  HISTORY_DEPOSIT_LIST: "historyDepositList",
  HISTORY_WITHDRAWAL_LIST: "historyWithdrawalList",
  BET_RECORD_GAME_LIST: "recordGameList",
  COMMON_ISSUES: "commonIssues",
  CS_LINK: "customerServiceLink",
  CS_LINK_NO_CURRENCY: "customerServiceLinkNoCurrency",
  BET_RECORD_GAME_TYPES: "betRecordGameTypes",
  BET_RECORD_GAME_LIST_BY_TYPE: "betRecordGameList",
  PROMOTION_TYPE: "promotionType",
  PROMOTION_LIST: "promotionList",
  PROMOTION_DETAIL: "promotionDetail",
  PROMOTION_DEPOSIT_RECORD: "promotionDepositRecord",
  ALL_LANG_LIST: "allLangList",
  LANG_LIST_BY_CURRENCY: "langListByCurrency",
  BANKS: "banks",
  VIRTUAL_CHANNELS: "virtual_channels",
  USER_BANK_ACCOUNT: "userBankAccount",
  USER_VIRTUAL_ACCOUNT: "userVirtualAccount",
  HOME_BANNER: "homeBanner",
  MARQUEE: "marquee",
  TRANSACTION_HISTORY: "transaction_history",
  DEPOSIT_COUNT: "deposit_count",
  DEPOSIT_PAYMENT_METHOD: "deposit_payment_method",
  WITHDRAW_PAYMENT_METHOD: "withdraw_payment_method",
  DEPOSIT_PAYMENT_ONLINE_METHOD: "deposit_payment_online_method",
  DEPOSIT_VIRTUAL_CHANNEL_LIST: "deposit_virtual_channel_list",
  DEPOSIT_BANK_CHANNEL_LIST: "deposit_bank_channel_list",
  DEPOSIT_ONLINE_METHOD: "deposit_online_method",
  DEPOSIT_ONLINE_METHOD_ALL: "deposit_online_method_all",
  DEPOSIT_ONLINE_PROVIDER: "deposit_online_provider",
  DEPOSIT_USDT_ONLINE_METHOD: "deposit_usdt_online_method",
  DEPOSIT_USDT_ONLINE_PROVIDER: "deposit_usdt_online_provider",
  EXCHANGE_CURRENCIES: "exchange_currencies",
  EXCHANGE_RATE: "exchange_rate",
  GET_EMAIL_VERIFY: "getEmailVerifyCode",
  ANNOUNCE: "noticeList",
  ANNOUNCE_DETAIL: "noticeDetail",
  MESSAGE: "messageList",
  USER_LEVEL_DOWNGRADE: "userLevelDowngrade",
  MESSAGE_DETAIL: "messageDetail",
  GAME_CATEGORY: "game_category",
  GAME_PRODUCT: "game_product",
  HOME_GAME_TYPE: "homeGameType",
  HOME_GAME_CATEGORY: "homeGameCategory",
  HOME_GAME_LIST: "homeGameList",
  VIP_USER_LEVEL: "vip_user_level",
  VIP_NEXT_USER_LEVEL: "vip_next_user_level",
  VIP_USER_LEVEL_INFO: "vip_user_level_info",
  VIP_GAME_REBATE: "vip_game_rebate",
  WITHDRAW_CHURN: "withdraw_churn",
  WITHDRAW_FEE: "withdraw_fee",
  USER_WALLET: "user_wallet",
  USER_WALLET_CACHE: "user_wallet_cache",
  USER_GAME_WALLET: "user_game_wallet",
  WALLET_GAME_LIST: "wallet_game_list",
  BET_RECORD: "bet_record",
  HOME_PROMOTION_BANNER: "home_promotion_banner",
  HOME_ALL_BANNER: "home_all_banner",
  USER_AREA_CODE: "user_area_code",
  SETTINGS: "settings",
  TG_LINK: "tg_link",
  TG_CHANNEL_LINK: "tg_channel_link",
  TG_BET_CHANNEL_LINK: "tg_bet_channel_link",
  FACEBOOK_LINK: "facebook_link",
  WHATSAPP_LINK: "whatsapp_link",
  WIN_PLATFORM_LIST: "win_platform_list",
  WIN_GAME_LIST: "win_game_list",
  WIN_GAME_CATEGORY: "win_game_category",
  WIN_GAME_WAY: "win_game_way",
  WIN_GAME_METHOD: "win_game_method",
  WIN_GAME_HISTORY: "win_game_history",
  WIN_BINANCE_KLINE: "win_binance_kline",
  WIN_SETTING: "win_setting",
  WIN_GAME_RULE: "win_game_rule",
  WIN_LATEST_NUMBER: "win_latest_number",

  HOME_1BBET_WIN_GAME: "home_1bbet_win_game",
  MG_GAME_LINK: "mg_game_link",
  T1_GAME_LINK: "t1_game_link",
  T1_GAME_LIST: "t1_game_list",
  PP_GAME_LINK: "pp_game_link",
  PP_GAME_LIST: "pp_game_list",
  PG_GAME_LINK: "pg_game_link",
  PG_GAME_LIST: "pg_game_list",
  YGG_GAME_LINK: "ygg_game_link",
  YGG_GAME_LIST: "ygg_game_list",
  EVOPLAY_GAME_LINK: "evoplay_game_link",
  EVOPLAY_GAME_LIST: "evoplay_game_list",
  JILI_GAME_LINK: "jili_game_link",
  JILI_GAME_LIST: "jili_game_list",
  SPRIBE_GAME_LINK: "spribe_game_link",
  SPRIBE_GAME_LIST: "spribe_game_list",
  PT_GAME_LINK: "pt_game_link",
  PT_GAME_LIST: "pt_game_list",
  PPLIVE_GAME_LINK: "pplive_game_link",
  PPLIVE_GAME_LIST: "pplive_game_list",
  FC_GAME_LINK: "fc",
  FC_GAME_LIST: "fc_game_list",
  CQ9_GAME_LINK: "cq9_game_link",
  CQ9_GAME_LIST: "cq9_game_list",
  PLAYSTAR_GAME_LINK: "playstar_game_link",
  PLAYSTAR_GAME_LIST: "playstar_game_list",
  WELIVE_GAME_LINK: "welive_game_link",
  WELIVE_GAME_LIST: "welive_game_list",
  WEBLOCKCHAIN_GAME_LINK: "weblockchain_game_link",
  WEBLOCKCHAIN_GAME_LIST: "weblockchain_game_list",
  WELOTTERY_GAME_LINK: "welottery_game_link",
  WELOTTERY_GAME_LIST: "welottery_game_list",
  TCG_GAME_LINK: "tcg_game_link",
  TCG_GAME_LIST: "tcg_game_list",
  YOUBET_GAME_LINK: "youbet_game_link",
  YOUBET_GAME_LIST: "youbet_game_list",
  AESEXY_GAME_LINK: "aesexy_game_link",
  AESEXY_GAME_LIST: "aesexy_game_list",
  SPRIBEONE_GAME_LINK: "spribeone_game_link",
  SPRIBEONE_GAME_LIST: "spribeone_game_list",
  WESPORT_GAME_LINK: "wesport_game_link",
  WESPORT_GAME_LIST: "wesport_game_list",
  LUCKYSPORT_GAME_LINK: "luckysport_game_link",
  LUCKYSPORT_GAME_LIST: "luckysport_game_list",
  YBSLOT_GAME_LINK: "ybslot_game_link",
  YBSLOT_GAME_LIST: "ybslot_game_list",
  WEFISH_GAME_LINK: "wefish_game_link",
  WEFISH_GAME_LIST: "wefish_game_list",
  WESLOT_GAME_LINK: "weslot_game_link",
  WESLOT_GAME_LIST: "weslot_game_list",
  FCFISH_GAME_LINK: "fcfish_game_link",
  FCFISH_GAME_LIST: "fcfish_game_list",
  JDBFISH_GAME_LINK: "jdbfish_game_link",
  JDBFISH_GAME_LIST: "jdbfish_game_list",
  JDBSLOT_GAME_LINK: "jdbslot_game_link",
  JDBSLOT_GAME_LIST: "jdbslot_game_list",
  VIACASINOLIVE_GAME_LINK: "viacasinolive_game_link",
  VIACASINOLIVE_GAME_LIST: "viacasinolive_game_list",
  FFFLIVE_GAME_LINK: "ffflive_game_link",
  FFFLIVE_GAME_LIST: "ffflive_game_list",
  WCF_GAME_LINK: "wcf_game_link",
  WCF_GAME_LIST: "wcf_game_list",
  JOLLYSPORT_GAME_LINK: "jollysport_game_link",
  ONEJDBFISH_GAME_LINK: "onejdbfish_game_link",
  ONEJDBFISH_GAME_LIST: "onejdbfish_game_list",
  ONEJDBSLOT_GAME_LINK: "onejdbslot_game_link",
  ONEJDBSLOT_GAME_LIST: "onejdbslot_game_list",
  MINIGAME_GAME_LINK: "minigame_game_link",
  MINIGAME_GAME_LIST: "minigame_game_list",
  SEARCH_GAME: "search_game",
  SEARCH_GAME_BY_GAME_CATEGORY_CODE: "search_game_by_game_category_code",
  HOT_GAME: "hot_game",
  ALL_GAME: "all_game",
  ONEPP_GAME_LINK: "onepp_game_link",
  ONEPP_GAME_LIST: "onepp_game_list",
  ONEPG_GAME_LINK: "onepg_game_link",
  ONEPG_GAME_LIST: "onepg_game_list",
  ONEHACKSAW_GAME_LINK: "onehacksaw_game_link",
  ONEHACKSAW_GAME_LIST: "onehacksaw_game_list",
  ONEJILISLOT_GAME_LINK: "onejilislot_game_link",
  ONEJILISLOT_GAME_LIST: "onejilislot_game_list",
  ONEJILIFISH_GAME_LINK: "onejilifish_game_link",
  ONEJILIFISH_GAME_LIST: "onejilifish_game_list",
  ONEJILICARD_GAME_LINK: "onejilicard_game_link",
  ONEJILICARD_GAME_LIST: "onejilicard_game_list",
  ONEJILICASINO_GAME_LINK: "onejilicasino_game_link",
  ONEJILICASINO_GAME_LIST: "onejilicasino_game_list",
  ONEEVOLIVE_GAME_LINK: "oneevolive_game_link",
  ONEEVOLIVE_GAME_LIST: "oneevolive_game_list",
  ONEPPLIVE_GAME_LINK: "onepplive_game_link",
  ONEPPLIVE_GAME_LIST: "onepplive_game_list",
  ONESABA_GAME_LINK: "onesaba_game_link",
  ONESABA_GAME_LIST: "onesaba_game_list",
  ONEGLOBAL_GAME_LINK: "oneglobal_game_link",
  ONEGLOBAL_GAME_LIST: "oneglobal_game_list",
  AG_GAME_LINK: "ag_game_link",
  AG_GAME_LIST: "ag_game_list",
  AG_TRIAL_GAME_LINK: "ag_trial_game_link",
  OMG_GAME_LINK: "omg_game_link",
  OMG_GAME_LIST: "omg_game_list",
  OMG_DEMO_GAME_LINK: "omg_demo_game_link",
  SBOSPORT_GAME_LINK: "sbosport_game_link",
  SBOSPORT_GAME_LIST: "sbosport_game_list",
  CRSPORT_GAME_LINK: "crsport_game_link",
  CRSPORT_GAME_LIST: "crsport_game_list",
  FBSPORT_GAME_LINK: "fbsport_game_link",
  FBSPORT_GAME_LIST: "fbsport_game_list",
  LOTTERY_GAME_RECORD: "lottery_game_record",
  CURRENT_LOTTERY: "current_lottery",
  GAME_WAY: "game_way",
  PROMO_EVENT: "promo_event",
  DEFAULT_DEPOSIT_PROMO: "defaultDepositPromo",
  DEPOSIT_CHURN: "deposit_churn",
  STATISTICS: "statistics",
  PRIZE_LIST: "prize_list",
  SPIN_RECORD: "spin_record",
  SHOW_BUBBLE: "show_bubble",
  RED_ENVELOPE: "red_envelope",
  GOLD_EGG: "gold_egg",
  GOLD_EGG_CONDITIONS: "gold_egg_conditions",
  SHORTS_RANDOM_DRAMA_LIST: "shorts_random_drama_list",
  THEATER_HOME_502: "theater_home_502",
  THEATER_DRAMA_LIST: "theater_drama_list",
  THEATER_CATEGORIES: "theater_categories",
  THEATER_RANKINGS: "theater_rankings",
};

export default queryKey;
